var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-content",
      attrs: { id: _vm.id },
      on: { mousedown: _vm.focus, touchstart: _vm.focus }
    },
    [
      _c("div", { staticClass: "text-content__handle tooltip-drag-handle" }, [
        _vm._v("::::::")
      ]),
      _vm._v(" "),
      _c("text-editor", {
        staticClass: "text-content__editor",
        class: { "text-content__editor--focused": _vm.hasFocus },
        attrs: { baseId: _vm.id, focus: _vm.hasFocus },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "text-content__delete tooltip-delete",
            on: {
              click: function($event) {
                _vm.deleteComponent()
              }
            }
          },
          [_vm._v("×\n    ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }